import React, {
  createContext,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from "react";

export type Row = {
  key: React.Key;
  Controllers_id: number;
  Executor_type: number;
  Executors_FIO_id: number;
  Executors_FIO_name: string;
  Executors_id: number;
  Executors_name: string;
  dateK_plan: string;
  eta_actions_doc_id: number;
  id: number;
  isMainExecutors: number;
  name_actions_doc: string;
  num_pp: number;
  parent_id: number;
  user_id: number;
  contact_person: string;
  Rez_Execurors_FIO_id: number;
  ExecutorFIO: string;
  gta_executers_fio_id: number;
  bta_document_id: number;
};

type TableContextValue = {
  rowsTable: Row[];
  setRowsTable: React.Dispatch<React.SetStateAction<Row[]>>;
  rowsTable2: Row[];
  setRowsTable2: React.Dispatch<React.SetStateAction<Row[]>>;
  fullList: Row[];
  setFullList: React.Dispatch<React.SetStateAction<Row[]>>;
};

// краще undefined, щоб зручно ловити відсутність провайдера
const RowsTableContext = createContext<TableContextValue | undefined>(undefined);

export function RowsTableProvider({
  children,
  initialRows = [],
}: {
  children: ReactNode;
  initialRows?: Row[];
}) {
  const [rowsTable, setRowsTable] = useState<Row[]>(initialRows);
  const [rowsTable2, setRowsTable2] = useState<Row[]>(initialRows);
  const [fullList, setFullList] = useState<Row[]>([]);


  // useMemo не обов’язковий, але зменшує зайві ререндери споживачів
  const value = useMemo(() => ({ rowsTable, setRowsTable, rowsTable2, setRowsTable2, fullList,  setFullList}), [rowsTable, rowsTable2, fullList]);

  return (
    <RowsTableContext.Provider value={value}>
      {children}
    </RowsTableContext.Provider>
  );
}

// зручний хук-обгортка
export function useRowsTable() {
  const ctx = useContext(RowsTableContext);
  if (!ctx) {
    throw new Error("useRowsTable must be used within <RowsTableProvider>");
  }
  return ctx;
}
